import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import Button from '../../../../../../components/button';
import ModalSlider from '../../../../../../components/modal-slider/modal-slider';
import { dadosPlanoDefault } from '../../../../constants';
import { DadosPlano } from '../dados-plano';
import string from '../../../../../../utils/string';
import {
  createPlanoVizi,
  updatePlanoVizi,
} from '../../../../../../services/vizi-planos';

export const ModalPlano = ({
  openModal,
  onCloseModal,
  setNotification,
  carregarPlanos,
  plano,
  whitelabel
}) => {
  const [dados, setDados] = useState(dadosPlanoDefault);
  const [loadingSave, setLoadingSave] = useState(false);

  const titlePrimeiroStep = dados?.id ? 'Alterar plano' : 'Novo plano';

  const handleDados = (value, field) => {
    if(field === "mesesFidelidade" && parseInt(value) < 0) return

    setDados({
      ...dados,
      [field]: value,
    });
  };

  const verificaErrors = () => {
    const hasRequiredValue =
      Boolean(dados.titulo) &&
      Boolean(dados.valorMensal)
      && Boolean(dados.mesesFidelidade)
      && Boolean(dados.valorMulta) ;
    return !hasRequiredValue;
  };

  const handleSavePlano = async () => {
    const save = dados.id ? updatePlanoVizi : createPlanoVizi;
    try {
      setLoadingSave(true);
      const planoId = await save({
        ...(dados?.id && { id: dados.id}),
        planoVizi:{
          titulo: dados.titulo,
          valorMensal: string.currencyMaskToFloat(dados.valorMensal),
          quantidadeAdicional: parseInt(dados.quantidadeAdicional),
          descricao: dados.descricao,
          mesesFidelidade: parseInt(dados.mesesFidelidade),
          valorMulta: string.currencyMaskToFloat(dados.valorMulta) / 100,
          valorAdicionalBeneficiario: string.currencyMaskToFloat(dados.valorAdicionalBeneficiario),
          valorAdicionalDependente: string.currencyMaskToFloat(dados.valorAdicionalDependente),
        }

      }, whitelabel);
      await carregarPlanos();
      if (Boolean(planoId)) {
        setNotification({
          variant: 'success',
          isOpen: true,
          message: dados?.id ? 'Procedimento vinculado atualizado com sucesso' : 'Procedimento vinculado com sucesso',
        });
      }
      setDados(dadosPlanoDefault);

      onCloseModal();
    } catch (error) {
      console.log(error)
      setNotification({
        variant: 'error',
        isOpen: true,
        message: 'erro ao executar essa ação',
      });
    } finally {
      setLoadingSave(false);
    }
  };

  const formatToString = (value) => {
    return value ? String(value).replace('.', ',') : "0";
  };

  useEffect(() => {
    if (plano?.id) {
      const valorMulta = formatToString(plano.valorMulta ? plano.valorMulta * 100 : 0);
      const valorMensal = formatToString(plano.valorMensal);
      const valorAnual = formatToString(plano.valorAnual);
      const valorAdicionalBeneficiario = formatToString(plano.valorAdicionalBeneficiario);
      const valorAdicionalDependente = formatToString(plano.valorAdicionalDependente);

      setDados({
        ...plano,
        valorMulta,
        valorMensal,
        valorAnual,
        valorAdicionalBeneficiario,
        valorAdicionalDependente,
      });
    } else {
      setDados(dadosPlanoDefault);
    }
  }, [plano?.id]);

  return (
    <ModalSlider
      isOpen={openModal}
      onClose={() => {
        setDados(dadosPlanoDefault);
        onCloseModal();
      }}
      title={titlePrimeiroStep}
    >
      <ContentModal>
        <Content>
          <DadosPlano dados={dados} handleDados={handleDados} />
        </Content>
        <Footer>
          <Button
            disabled={verificaErrors() || loadingSave}
            onClick={handleSavePlano}
          >
            {dados.id ? 'Atualizar' : 'Salvar'}
          </Button>
        </Footer>
      </ContentModal>
    </ModalSlider>
  );
};

const ContentModal = styled.div`
  grid-template-rows: 1fr 80px;
  display: grid;
  height: 100%;
`;

const Content = styled.div`
  height: 100%;
  height: calc(100vh - 200px);
`;

const Footer = styled.div`
  min-height: max-content;
  padding-top: 16px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;
